import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=72dda4ac&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=72dda4ac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dda4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72dda4ac')) {
      api.createRecord('72dda4ac', component.options)
    } else {
      api.reload('72dda4ac', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=72dda4ac&scoped=true&", function () {
      api.rerender('72dda4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OZFmTReKQEwM/JS/comp/Paginate.vue"
export default component.exports